import TabBarComponent, { TabProps } from "./tabbar/Tabbar";
import TabBarItem from "./tabbar/TabItem";

import "./index.scss";

export interface TabBarComponent<P = {}> extends React.FC<P> {
  Item: typeof TabBarItem;
}

const TabBar = TabBarComponent as TabBarComponent<TabProps>;

TabBar.Item = TabBarItem;

export default TabBar;
